import { render, staticRenderFns } from "./TxnPending.vue?vue&type=template&id=050c8d2e&scoped=true&"
import script from "./TxnPending.vue?vue&type=script&lang=js&"
export * from "./TxnPending.vue?vue&type=script&lang=js&"
import style0 from "./TxnPending.vue?vue&type=style&index=0&id=050c8d2e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "050c8d2e",
  null
  
)

export default component.exports